require("../../../static/js/academy-content-navigation-ucitsblock.js");
